import React, { useState, useEffect } from "react";
import * as R from "ramda";
import { utmProps } from "../../utils/utm";

interface ExternalLinkProps {
    id?: string;
    children: JSX.Element | JSX.Element[];
    href: string;
    className?: string;
    onClick?: () => boolean | void;
    queryParams?: { [key: string]: string };
    gtag?: boolean;
    target?: "_blank" | "_self";
}

const ExternalLink: React.FC<ExternalLinkProps> = ({ id, children, href, target = "_blank", className = "", onClick, queryParams, gtag = true }: ExternalLinkProps) => {
    const [query, setQuery] = useState<string>();
    useEffect(() => {
        const utmData: Partial<utmProps> = JSON.parse((typeof window !== "undefined" && window.localStorage.getItem("utm_data")) || "{}");
        const filteredUtmData = gtag ? R.filter((item) => !!item)(utmData) : {};
        setQuery(
            Object.keys({ ...queryParams, ...filteredUtmData })
                .map((key) => `${key}=${{ ...queryParams, ...filteredUtmData }[key]}`)
                .join("&")
        );
    }, [queryParams]);
    return (
        <a id={id} className={className} href={`${href}${query && query != "" ? `?${query}` : ""}`} target={target} onClick={onClick && (() => onClick)}>
            {children}
        </a>
    );
};

export default ExternalLink;
